export default __webpack_public_path__ + "static/christmas-lights-3e68380c59beddf6e93161d85ab82ca8.svg";